import {
  hasAnyGlazedWall,
  isGlazedWall,
} from "../../../../helpers-shared/configuration/utils"

export const homelift = newValues => {
  //Si está seleccionado todas las paredes y la izda o front es de cristal ponemos primer material
  if (newValues.all_walls_same && hasAnyGlazedWall(newValues)) {
    newValues.CCAB_PARED_FRONT_ACABADO = "NCC_01"
    newValues.CCAB_PARED_IZDA_ACABADO = "NCC_01"
    newValues.CCAB_PARED_DCHA_ACABADO = "NCC_01"
  }

  //Si el embarque es 270, la pared de fondo es de cristal y queremos poner cristal en la pared derecha, ponemos el material del prediseño
  if (
    newValues.CCAB_EMBARQUE === "270" &&
    isGlazedWall(newValues.CCAB_PARED_FRONT_ACABADO) &&
    isGlazedWall(newValues.CCAB_PARED_DCHA_ACABADO)
  ) {
    newValues.CCAB_PARED_DCHA_ACABADO = "NCW_01"
  }

  return newValues
}
